import { Edit, SimpleForm, TextInput, SelectInput } from 'react-admin';

export const QualificationTypeEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" label="Type Name" required />
      <TextInput source="description" label="Description" multiline />
      <SelectInput source="status" choices={[
        { id: 'Active', name: 'Active' },
        { id: 'Inactive', name: 'Inactive' },
      ]} />
    </SimpleForm>
  </Edit>
);
